import { render, staticRenderFns } from "./institution-prescr-charts.vue?vue&type=template&id=00a50852&scoped=true&lang=pug&"
import script from "./institution-prescr-charts.vue?vue&type=script&lang=ts&"
export * from "./institution-prescr-charts.vue?vue&type=script&lang=ts&"
import style0 from "./institution-prescr-charts.vue?vue&type=style&index=0&id=00a50852&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00a50852",
  null
  
)

export default component.exports